import React from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import { useLang } from "~/hooks/useLang";
import { useHookstate } from "@hookstate/core";
import { useHistory } from "react-router-dom";
import { createWarehouseCheckout } from "../services";
import type { ItemCheckout, ItemMaterialCheckout } from "../interface";
import Layout from "~/components/Layout";
import InternalContent from "~/components/Layout/components/InternalContent";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import WarehouseCheckoutResponsibles from "../components/ResponsiblesCheckout";
import EquipmentsCheckout from "../components/EquipmentsCheckout";
import MaterialsCheckout from "../components/MaterialsCheckout";

export default function CheckoutWarehouse() {
  const { translate } = useLang()
  const history = useHistory()
  const warehouseId = useHookstate<number | null>(null)
  const userId = useHookstate<number | null>(null)
  const equipmentsItens = useHookstate<ItemCheckout[]>([
    { itemId: null, groupId: null, quantity: null, equipment: null }
  ])
  const materialsItens = useHookstate<ItemMaterialCheckout[]>([
    { itemId: null, groupId: null, quantity: null, material: null }
  ])
  
  const handleCreateCheckout = () => {
    if (warehouseId.get() !== null || userId.get() !== null) {

      const equipments = equipmentsItens.get()
        .filter(item => item.equipment?.id !== null)
        .map(item => ({
          equipment_id: Number(item.equipment?.id)
        }))

      const materials = materialsItens.get()
        .filter(item => item.material?.id !== null && item.material?.totalInventory !== null)
        .map(item => ({
          material_id: Number(item.material?.id),
          quantity_at_checkout: Number(item.material?.totalInventory)
        }))

      createWarehouseCheckout({
        warehouseId: Number(warehouseId.get()),
        receivedByUserId: Number(userId.get()),
        equipments,
        materials
      }).then((response) => {
        if (response.status === 200) {
          history.push('/warehouse-checkout')
        }
      })
    }
  }

  return (
    <Layout marginLayout={true}>
      <InternalHeader title={translate('Create new checkout')} />
      <InternalContent expandButton={false}>
        <Typography variant="h6" marginBottom={2}>
          {translate('Responsibles')}
        </Typography>
        <WarehouseCheckoutResponsibles
          warehouseId={warehouseId}
          userId={userId}
        />
        <Divider sx={{ marginY: 2 }} />
        <EquipmentsCheckout warehouseId={warehouseId} equipmentsItens={equipmentsItens} />
        <Divider sx={{ marginY: 2 }} />
        <MaterialsCheckout warehouseId={warehouseId} materialsItens={materialsItens} />
        <Grid container display={'flex'} alignItems={'center'} justifyContent={'flex-end'} gap={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push("/warehouse-checkout")}
          >
            {translate('Cancel')}
          </Button>
          <Button
            onClick={() => handleCreateCheckout()}
            variant="contained"
            color="primary"
          >
            {translate('Save')}
          </Button>
        </Grid>
      </InternalContent>
    </Layout>
  )
}